import React from 'react';
import { refundBadge, refundStatusOf, BADGE_COLOURS } from './refundLogic';

/**
 * "Part refunded" / "Refunded" pill. Renders nothing for a sale with no
 * refunds, so it can sit anywhere a sale is shown.
 *
 *   <RefundBadge sale={booking} />          reads refundStatus / refundedTotal
 *   <RefundBadge status="partial" small />
 */
export default function RefundBadge({ sale, status, small = false, style }) {
  const b = refundBadge(status || refundStatusOf(sale));
  if (!b) return null;
  const c = BADGE_COLOURS[b.tone];
  return (
    <span
      className="rf-badge"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: small ? '1px 6px' : '2px 8px',
        borderRadius: small ? '4px' : '6px',
        fontSize: small ? '10px' : '11px',
        fontWeight: 600,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        background: c.background,
        color: c.color,
        ...(style || {}),
      }}
    >
      {b.label}
    </span>
  );
}
